import { useEffect, useState } from 'react';

/**
 * @description Returns the window inner width.
 * @note This hook is used to force a re-render when the window inner width changes.
 * @listens window#resize - When the window is resized.
 * @returns {number} The window inner width.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth MDN - Window.innerWidth}
 * @example
 * const windowInnerWidth = useWindowInnerWidth();
 */
export function useWindowInnerWidth() {
  const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    /**
     * @description Updates the window inner width.
     */
    function onResize() {
      setWindowInnerWidth(window.innerWidth);
    }

    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return windowInnerWidth;
}

export default useWindowInnerWidth;
